// Mirrors part_finder_attribute.status on the backend; a save only asks for DRAFT or PUBLISHED.
// Only a family can be UNPUBLISHED: taken off the finder until it is published again;
// UNPUBLISHED_MODIFIED while it has a draft on top of the version it was un-published with.
export enum AttributeStatus {
  DRAFT = 'draft',
  MODIFIED = 'modified',
  PUBLISHED = 'published',
  UNPUBLISHED = 'unpublished',
  UNPUBLISHED_MODIFIED = 'unpublished_modified',
}
